import { render } from "./RevertPromotionModal.vue?vue&type=template&id=a41c05e4&ts=true"
import script from "./RevertPromotionModal.vue?vue&type=script&lang=ts"
export * from "./RevertPromotionModal.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__